import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://qa-applicationbackend-124917071187.us-east4.run.app/api',
  commandCenterUrl: 'https://qa-commandcenter.transend.io',
};
